export enum ImageType {
	ArtCrop = "art_crop",
	Large = "large",
	Small = "small",
	Normal = "normal",
}

export const getImageUrl = (
	imageUrlBase: string,
	card_id: string,
	image_type: ImageType,
	side: "front" | "back" = "front",
) => {
	return `${imageUrlBase}/${card_id}/${side}/${image_type}.webp`;
};
